import { DetailTemplate } from "../../templates/DetailTemplate";
import { MainTemplate } from "../../templates/MainTemplate";
import { useClientDetail } from "./hook";

export const ClientDetailPage: React.FC = () => {
  const { clientDetails, handleCancel, handleEdit } = useClientDetail();

  return (
    <MainTemplate title="顧客詳細" useFitHeight>
      <DetailTemplate
        detailItems={clientDetails}
        onCancel={handleCancel}
        onEdit={handleEdit}
      />
    </MainTemplate>
  );
};
